import React, { useEffect } from "react";
import base from "../../assets/base.svg";
import logoIC from "../../assets/logo.svg";
import "./AccountVerified.scss";
import verified from "../../assets/verified.svg";
import QRComponent from "../../components/qrComponent/QRComponent";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/button/Button";
const AccountVerified: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state?.data ?? null;

  useEffect(() => {
    if (!data) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className='AccountVerified'>
      <div className='header-tab'>Customer Registration</div>
      <div className='content-register-veri'>
        <div
          className='left-content-register'
          style={{ backgroundImage: `url(${base})` }}
        >
          <div className='left-logo-container'>
            <img alt='' src={logoIC} className='logoic-img' />
          </div>
          <div className='left-text-container'>
            The multipurpose tool you need to succeed in business
          </div>
        </div>
        <div className='right-content-register'>
          <div className='content-verified'>
            <div className='verified-header'>
              <div className='verified-header-left'>
                <img alt='' src={verified} className='verified-ic ' />
                <div>
                  <div className='verified-header-text'>Account Verified</div>
                </div>
              </div>
            </div>
            <div className='verified-content-qr'>
              <div className='verified-content-qr-text'>
                Account verified! Scan this QR Code with other devices for quick
                access or link your account with orders.
              </div>
              <div className='verified-qr-cont'>
                {data && <QRComponent value={data?.URL} />}
              </div>
              <div className='verified-id-cont'>{data && data?.UserID}</div>
            </div>
          </div>
          <div className='pd-btn-cont-veri'>
            <Button
              text='Back'
              isPrimary={false}
              onClick={() => {
                navigate("/");
              }}
              isBorder
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AccountVerified;
